import { Controller } from "@hotwired/stimulus"

// Accessibility text-size control. Scales the root font size (the admin is
// rem-based, so spacing and type scale together) and remembers the choice.
const KEY = "admin-font-scale"
const STEPS = [0.875, 1.0, 1.125, 1.25, 1.375]
const DEFAULT = 1 // index into STEPS (100%)

export default class extends Controller {
  static targets = ["label"]

  connect() {
    const saved = parseInt(localStorage.getItem(KEY), 10)
    this.index = Number.isInteger(saved) ? this.clamp(saved) : DEFAULT
    this.apply()
  }

  increase() { this.set(this.index + 1) }
  decrease() { this.set(this.index - 1) }
  reset() { this.set(DEFAULT) }

  set(index) {
    this.index = this.clamp(index)
    localStorage.setItem(KEY, this.index)
    this.apply()
  }

  apply() {
    const scale = STEPS[this.index]
    document.documentElement.style.fontSize = `${scale * 100}%`
    if (this.hasLabelTarget) this.labelTarget.textContent = `${Math.round(scale * 100)}%`
  }

  clamp(index) {
    return Math.max(0, Math.min(STEPS.length - 1, index))
  }
}
